@if (enabled) {
  <!-- Implement logic here -->
}
